import { Controller } from "@hotwired/stimulus"

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

export default class extends Controller {
  static values = {
    delay: { default: 100, type: Number },
    events: { type: Array, default: ["change", "input"] }
  }

  initialize() {
    this.submit = debounce((e) => {
      if (e.target.classList.contains("easepick-wrapper")) return
      (e.target.form ?? this.element).requestSubmit();
    }, this.delayValue)
  }

  connect = () => {
    this.element.dataset.action = this.eventsValue.map(e => `${e}->submit-on-change#submit`).join(" ")
  }
}
